export default __webpack_public_path__ + "static/media/3.2beea7a9.jpg";